import { Dialog, DialogContent } from '@/components/new/ui'

import { EditConfig } from './types'
import { ImageEditor } from './ImageEditor'

export type ImageEditorDialogProps = {
    open: boolean
    image: File | Blob | string
    config: EditConfig
    onOpenChange: (open: boolean) => void
    onSubmit: (image: Blob) => void
    disablePointerDismissal?: boolean
}

export const ImageEditorDialog = ({
    open,
    image,
    config,
    onOpenChange,
    onSubmit,
    disablePointerDismissal = true,
}: ImageEditorDialogProps) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange} disablePointerDismissal={disablePointerDismissal}>
            <DialogContent
                showCloseButton={false}
                className="flex max-h-[calc(100dvh-2rem)] max-w-4xl flex-col gap-0 overflow-hidden border-0 bg-transparent p-0 shadow-none sm:max-w-4xl"
            >
                <ImageEditor
                    image={image}
                    config={config}
                    onCancel={() => onOpenChange(false)}
                    onSubmit={(editedImage) => onSubmit(editedImage)}
                />
            </DialogContent>
        </Dialog>
    )
}
